/**
 * ProTrustBanner
 *
 * Sand trust band shown below the Step 5 appointment-summary total: a cobalt
 * shield beside "Your beauty pro is vetted and background-checked." Static,
 * always rendered. ShieldIcon is an inline SVG taking a color prop, matching
 * the codebase's inline-icon pattern.
 */
import React from 'react'
import styled from '@emotion/styled'
import { mq } from '../../../../helpers'
import { gsColors } from '../../../../styles/Variables'
import { Text } from '../../../../styles/Components'

const ShieldIcon = ({ color = gsColors.cobalt, glyphColor = gsColors.white, size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <circle cx="12" cy="12" r="12" fill={color} />
    <path d="M10.1524 12.3415C9.6508 11.8451 9.4 11.2355 9.4 10.5127C9.4 9.78982 9.6508 9.18021 10.1524 8.68383C10.6539 8.18732 11.2697 7.93907 12 7.93907C12.7303 7.93907 13.3461 8.18732 13.8476 8.68383C14.3492 9.18021 14.6 9.78982 14.6 10.5127C14.6 11.2355 14.3492 11.8451 13.8476 12.3415C13.3461 12.838 12.7303 13.0863 12 13.0863C11.2697 13.0863 10.6539 12.838 10.1524 12.3415ZM12.9984 11.5009C13.2661 11.2361 13.4 10.9066 13.4 10.5127C13.4 10.1187 13.2661 9.78929 12.9984 9.52441C12.7308 9.25939 12.398 9.12689 12 9.12689C11.602 9.12689 11.2692 9.25939 11.0016 9.52441C10.7339 9.78929 10.6 10.1187 10.6 10.5127C10.6 10.9066 10.7339 11.2361 11.0016 11.5009C11.2692 11.766 11.602 11.8985 12 11.8985C12.398 11.8985 12.7308 11.766 12.9984 11.5009ZM12 20C10.2697 19.5329 8.8372 18.5248 7.7024 16.9756C6.56747 15.4264 6 13.6945 6 11.7797V7.2234L12 5L18 7.2234V11.7797C18 13.6945 17.4325 15.4264 16.2976 16.9756C15.1628 18.5248 13.7303 19.5329 12 20ZM12 6.26384L7.2 8.03805V11.7797C7.2 12.533 7.309 13.2615 7.527 13.9651C7.74487 14.6685 8.04767 15.3249 8.4354 15.9341C8.97487 15.6619 9.53973 15.4493 10.13 15.296C10.7203 15.1427 11.3436 15.066 12 15.066C12.6564 15.066 13.2797 15.1427 13.87 15.296C14.4603 15.4493 15.0251 15.6619 15.5646 15.9341C15.9523 15.3249 16.2551 14.6685 16.473 13.9651C16.691 13.2615 16.8 12.533 16.8 11.7797V8.03805L12 6.26384ZM10.5116 16.4197C10.0352 16.5304 9.5852 16.6858 9.1616 16.8857C9.55853 17.3223 9.9952 17.6998 10.4716 18.0181C10.948 18.3363 11.4575 18.5797 12 18.7482C12.5425 18.5797 13.0507 18.3363 13.5246 18.0181C13.9985 17.6998 14.4339 17.3223 14.8308 16.8857C14.4072 16.6858 13.9585 16.5304 13.4846 16.4197C13.0107 16.3091 12.5159 16.2538 12 16.2538C11.4841 16.2538 10.988 16.3091 10.5116 16.4197Z" fill={glyphColor} />
  </svg>
)

const Banner = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  background-color: ${gsColors.sand};
  padding: 20px 24px;
  margin-top: 24px;

  svg {
    flex-shrink: 0;
  }

  p {
    font-weight: 600 !important;
    font-size: 16px;

    ${mq('max', '768px')} {
      font-size: 14px;
    }
  }
`

const ProTrustBanner = () => (
  <Banner>
    <ShieldIcon />
    <Text fontSize={16} weight={600} lineHeight='138%'>
      Your beauty pro is vetted and background-checked
    </Text>
  </Banner>
)

export default ProTrustBanner
